import * as apis from "@/apis/common";
import FPTS from "./from-password-to-set";
import FSTS from "./from-security-to-set";
import FORGET from "./forget";

let common = {
    resetPassword(context, params) {
        return apis.resetPassword(params);
    },
    getHomeSecurities({ commit }, params) {
        return apis.getHomeSecurities(params).then(res => {
            commit("SET_SECURITIES", res);
            return res;
        });
    },
    getUserSecurities({ commit }, params) {
        return apis.getUserSecurities(params).then(res => {
            commit("SET_SECURITIES", res);
            return res;
        });
    }
};

export default Object.assign({}, common, FPTS, FSTS, FORGET);
